module.exports = "\r\n.category-item{\r\n   \r\n    border-radius: 50%;\r\n}\r\n.shop-by-categories{\r\n    padding-top: 20px;\r\n    background: #c4c4c438;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/brands/brands.component.css
// module id = ./src/app/components/brands/brands.component.css
// module chunks = main